"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useValidCurriculum = void 0;
var curricula_1 = require("../constants/curricula");
var state_1 = require("../core/state");
/**
 * This hook indicates if some section of the UI should be hidden based on Curriculum
 *
 * It is pending to implement a more robust solution post pivot with CMS and RIPL.
 * https://digital-greatminds.atlassian.net/browse/DIGI-40939
 */
var useValidCurriculum = function () {
    var _a;
    var globalNav = (0, state_1.useGlobalNavV2)();
    var curriculum = (_a = globalNav === null || globalNav === void 0 ? void 0 : globalNav.selected) === null || _a === void 0 ? void 0 : _a.code;
    var hideOnMyLibrary = curricula_1.INVALID_CURRICULA_FOR_MY_LIBRARY.includes(curriculum);
    return { hideOnMyLibrary: hideOnMyLibrary };
};
exports.useValidCurriculum = useValidCurriculum;
